import { useEntity } from "apps/console/context/entity";
import DynamicFieldConfigType from "../../types/DynamicFieldConfigType";
import { usePostApiData } from "shared/datalayer";
import FormSelectDropdownField from "shared/form/fields/selectDropdown";
import DynamicFieldLabel from "../DynamicFieldLabel";
import ConsoleApi from "apps/console/enums/consoleApi";
import React from "react";
import { FormFieldOption } from "shared/form/fields/types";
import { ApiOptionSearchRequest } from "shared/types/ApiOptionSearchRequest";
import ContextEntityType from "shared/enums/ContextEntityType";
import FieldRenderSubType from "shared/enums/FieldRenderSubType";
import { ApiOption } from "shared/types/ApiOption";

const emptyOptions: Array<FormFieldOption> = [];
export default function OrganizationLevelField(props: DynamicFieldConfigType) {
  const { eventId } = useEntity();
  const { mutateAsync: getOptions } = usePostApiData<Array<ApiOption>, ApiOptionSearchRequest>(
    ConsoleApi.GET_OPTION_FOR_FIELD
  );
  const [options, setOptions] = React.useState(emptyOptions);
  React.useEffect(() => {
    async function fetchOptions() {
      const ops = await getOptions({
        contextId: eventId,
        contextType: ContextEntityType.EVENT,
        fieldRenderSubType: FieldRenderSubType.ORGANIZATION_LEVEL
      });
      setOptions(
        ops
          .sort(item => item.displayOrder)
          .map((option: ApiOption) => {
            return { label: option.value, value: option.id };
          })
      );
    }
    fetchOptions();
  }, [eventId, getOptions, props.schemaObj.id, props.schemaObj.renderSubType, props.schemaObj.renderType]);

  return (
    <FormSelectDropdownField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      required={props.schemaObj.mandatory}
      disabled={props.schemaObj.disabled}
      options={options}
      validate={props.validationFn}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
    />
  );
}
